







































































import { Vue, Component, Prop, p } from "av-ts";

@Component
export default class TopicChip extends Vue {
    @Prop linkTo = p<string>({
        required: false,
        default: ""
    });

    @Prop disabled = p<boolean>({
        required: false,
        default: false
    });

    get status() {
        return {
            disabled: this.disabled,
            selected: !this.disabled
        };
    }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/util/TopicChip.vue